// Utilities for the "Acciones de Personal" document generator.
// Variables are written as {{Nombre_Campo}} inside the template HTML.

export const CATEGORIAS = [
  "Administrativo",
  "Amonestación",
  "Suspensión",
  "Ascenso",
  "Permiso",
  "Permiso sin goce salarial",
  "Contrato",
  "Otro",
];

const VAR_RE = /\{\{\s*([A-Za-zÁÉÍÓÚÑáéíóúñ0-9_]+)\s*\}\}/g;

// Extract unique variable names from an HTML/text content.
export function extractVariables(content = "") {
  const found = new Set();
  let m;
  const re = new RegExp(VAR_RE.source, "g");
  while ((m = re.exec(content)) !== null) found.add(m[1]);
  return Array.from(found);
}

// Pretty label: "Nombre_Trabajador" -> "Nombre Trabajador"
export function prettyLabel(varName = "") {
  return varName.replace(/_/g, " ").trim();
}

// Replace {{var}} placeholders with values. Returns HTML string.
export function fillTemplate(content = "", values = {}) {
  return content.replace(VAR_RE, (_, key) => {
    const v = values[key];
    return v != null && v !== "" ? String(v) : `{{${key}}}`;
  });
}

// Normalise a variable name for fuzzy matching with employee/company fields.
const norm = (s) => s.toLowerCase().replace(/[_\s]+/g, "");

// Build a values dict auto-filled from an empleado + empresa record.
export function autoFillFromTrabajador(variables = [], empleado = {}, empresa = {}) {
  const today = new Date().toLocaleDateString("es-CR", { day: "numeric", month: "long", year: "numeric" });
  const nombreCompleto = `${empleado.nombre || ""} ${empleado.apellidos || ""}`.trim();
  const sources = {
    nombretrabajador: nombreCompleto,
    nombrecompleto: nombreCompleto,
    nombre: nombreCompleto,
    identificaciontrabajador: empleado.cedula || "",
    identificacion: empleado.cedula || "",
    cedula: empleado.cedula || "",
    puestotrabajo: empleado.puesto || "",
    puesto: empleado.puesto || "",
    departamento: empleado.departamento || "",
    fechainicio: empleado.fecha_ingreso || "",
    fechaingreso: empleado.fecha_ingreso || "",
    salario: empleado.salario_base != null ? String(empleado.salario_base) : "",
    salariobase: empleado.salario_base != null ? String(empleado.salario_base) : "",
    telefono: empleado.telefono || "",
    correo: empleado.correo || empleado.email || "",
    email: empleado.correo || empleado.email || "",
    direccion: empleado.direccion || "",
    fecha: today,
    fechahoy: today,
    nombreempresa: empresa.razon_social || empresa.nombre || "",
    cedulajuridica: empresa.cedula_juridica || "",
    direccionempresa: [empresa.provincia, empresa.canton, empresa.direccion].filter(Boolean).join(", "),
    representantelegal: empresa.representante_legal || "",
  };
  const out = {};
  variables.forEach((v) => {
    const key = norm(v);
    if (sources[key] != null) out[v] = sources[key];
  });
  return out;
}
